import React, {Component} from 'react';
import FontAwesome from './vendor/fontawesome-free-5.0.6/svg-with-js/js/fontawesome-all.js';
import 'react-rangeslider/lib/index.css'
import './SoundsList.css';
import firebase from './firebase.js';
import sounds from './sounds.js';
import Sound from './Sound.js';
import Favourites from './Favourites.js';
import isUndefined from 'lodash.isundefined';
import toastr from 'toastr';
import 'toastr/build/toastr.css';
import classNames from 'classnames';
import {Button, Form, FormGroup, Label, Input} from 'reactstrap';

toastr.options = {
    "progressBar": true
};

function MutedIcon(props) {
    return (
        <span className="fa-layers fa-fw fa-2x">
            <i style={{color: '#dcdcdc'}} className={'fas fa-volume-up'}></i>
            <i style={{color: '#2c303b'}} className="fa-inverse fas fa-times" data-fa-transform="shrink-6"></i>
        </span>
    );
}

function NonMutedIcon(props) {
    return (
        <span className="fa-layers fa-fw fa-2x">
            <i style={{color: '#dcdcdc'}} className={'fas fa-volume-up'}></i>
            <i style={{color: 'transparent'}} className="fa-inverse fas fa-times" data-fa-transform="shrink-6"></i>
        </span>
    );
}

function getCombinationsRef() {
    return '/users/' + this.props.userId + '/combinations';
}

class SoundsList extends React.Component {
    constructor(props) {
        super(props);
        console.log("this.props.user", this.props.user);
        this.state = {
            isMuted: false,
            sounds: sounds,
            combinationTitle: '',
            playingCombinationTitle: '',
            combinations: []
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClickPlayCombination = this.handleClickPlayCombination.bind(this);
        this.handleClickDeleteCombination = this.handleClickDeleteCombination.bind(this);
        this.handleChangeVolume = this.handleChangeVolume.bind(this);
    }

    mute() {
        console.log("mute");
        const sounds = this.state.sounds.slice();
        const isMuted = !this.state.isMuted;
        if (isMuted) {
            sounds.forEach(sound => {
                if (sound.isPlaying) {
                    sound.sound.pause();
                }
            });
        } else {
            sounds.forEach(sound => {
                if (sound.isPlaying) {
                    sound.sound.play('main');
                }
            });
        }

        this.setState({isMuted: isMuted, sounds: sounds});
    }

    handleChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleChangeVolume(i, volume) {
        const sounds = this.state.sounds.slice();
        sounds[i].sound.volume(volume / 100.0);
        sounds[i].volume = volume;
        this.setState({
            playingCombinationTitle: '',
            sounds: sounds
        });
    }

    handleClick(i) {
        const sounds = this.state.sounds.slice();
        sounds[i].isPlaying = !sounds[i].isPlaying;
        sounds[i].sound.volume(sounds[i].volume / 100.0);
        if (!this.state.isMuted) {
            // We only want to play if it is not muted
            // likewise if it is muted there is no point in pausing
            sounds[i].isPlaying ? sounds[i].sound.play('main') : sounds[i].sound.pause();
        }

        this.setState({
            playingCombinationTitle: '',
            sounds: sounds
        });
    }

    handleClickPlayCombination(combinationToPlay) {
        // alert('playCombination ' + combinationToPlay.combinationTitle);
        let sounds = this.state.sounds.slice();
        sounds = sounds.map(sound => {
            sound.isPlaying = false;
            sound.sound.pause();
            return sound;
        });

        for (let soundFromCombination of combinationToPlay.sounds) {
            let sound = sounds.find(s => s.id === soundFromCombination.id);
            if (isUndefined(sound)) {
                console.warn('Tried to play a sound but the id is no longer present ', soundFromCombination);
                continue;
            }

            sound.volume = soundFromCombination.volume;
            sound.isPlaying = true;

            if (!this.state.isMuted) {
                // We only want to play if it is not muted
                sound.sound.play('main');
            }
        }

        this.setState({
            playingCombinationTitle: combinationToPlay.combinationTitle,
            sounds: sounds
        });
    }

    handleClickDeleteCombination(combinationToDeleteId) {
        console.log('deleting combination ', combinationToDeleteId);
        const combinationRef = firebase.database().ref((getCombinationsRef.call(this) + `/${combinationToDeleteId}`));
        combinationRef.remove();
        toastr.info('Combination deleted');
    }

    handleSubmit(e) {
        console.log('submitting');
        e.preventDefault();

        // Validate for empty combination name
        if (this.state.combinationTitle.length === 0) {
            console.log('empty combination name');
            toastr.error('Combinations need to have a name.');
            return;
        }

        if(this.hasCombinationWithSameTitle(this.state.combinations, this.state.combinationTitle)){
            console.log('there is already a combination with the specified name ', this.state.combinationTitle);
            toastr.error('You already have a combination with that name. Choose another.');
            return;
        }

        let playingSounds
            = this.state.sounds.filter(sound => sound.isPlaying === true);

        if (playingSounds.length === 0) {
            toastr.error('Can\'t save a combination when no sounds are playing. Try playing one first.');
            return;
        }

        let playingSoundsToSave = {};
        for (let playingSound of playingSounds) {
            playingSoundsToSave[playingSound.id] = {
                volume: playingSound.volume
            };
        }

        console.log('playingSoundsToSave ', playingSoundsToSave);

        const combinationsRef = firebase.database().ref(getCombinationsRef.call(this));
        const combination = {
            combinationTitle: this.state.combinationTitle,
            sounds: playingSoundsToSave
        };
        combinationsRef.push(combination);
        this.setState({
            combinationTitle: '',
            playingCombinationTitle: combination.combinationTitle
        });

        toastr.success('New combination saved. Good job!');
    }

    hasCombinationWithSameTitle(existingCombinations, newCombinationTitle) {
        return existingCombinations.find(combination => combination.combinationTitle === newCombinationTitle);
    }

    renderSounds() {
        return this.state.sounds.map((sound, index) => {
            return <Sound
                key={sound.id}
                index={index}
                sound={sound}
                handleChangeVolume={this.handleChangeVolume}
                onClick={() => this.handleClick(index)}
            />
        })
    }

    componentDidUpdate(prevProps, prevState) {
        // userId could have been undefined when mounting or the logged in user could have changed
        if(this.hasUserIdChanged(prevProps)) {
            this.listenForCombinationChangesIfUserIdDefined();
        }
    }

    hasUserIdChanged(prevProps) {
        return prevProps.userId !== this.props.userId;
    }

    componentDidMount() {
        this.listenForCombinationChangesIfUserIdDefined();
    }

    listenForCombinationChangesIfUserIdDefined() {
        if (this.props.userId) {
            const combinationsRef = firebase.database().ref(getCombinationsRef.call(this));
            console.log('combinationsRef ', combinationsRef);
            combinationsRef.on('value', (snapshot) => {
                let combinations = snapshot.val();

                // We are converting the data to arrays.
                // We do this because firebase does not support arrays.
                // And here you can read why firebase does not support arrays http://firebase.googleblog.com/2014/04/best-practices-arrays-in-firebase.html
                let newState = [];
                for (let combination in combinations) {
                    let sounds = [];
                    for (let sound in combinations[combination].sounds) {
                        sounds.push({
                            id: sound,
                            volume: combinations[combination].sounds[sound].volume
                        });
                    }
                    newState.push({
                        id: combination,
                        combinationTitle: combinations[combination].combinationTitle,
                        sounds: sounds
                    });
                }

                console.log('newState ', newState);
                this.setState({
                    combinations: newState
                });
            });
        }
    }

    render() {
        const isMuted = this.state.isMuted;

        return (

            <div className="album py-5 bg-light">
                <div className="container">
                    <div className="d-flex">

                        {this.props.username ?
                            <React.Fragment>
                                <div className="pt-3">
                                    {this.state.playingCombinationTitle ?
                                        <h3>{this.state.playingCombinationTitle}</h3>
                                        :
                                        <form className="form-inline" onSubmit={this.handleSubmit}>
                                            <div className="form-group mr-sm-2 mb-2">
                                                <div className="input-group">
                                                    <input type="text" className="form-control" name="combinationTitle"
                                                           placeholder="Combo name" onChange={this.handleChange}
                                                           value={this.state.combinationTitle}/>
                                                    <div className="input-group-append">
                                                        <button className="btn btn-outline-primary" type="submit">Save
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    }
                                </div>
                                {/*<div className="p-3">*/}
                                    {/**/}
                                {/*</div>*/}
                            </React.Fragment>
                            :
                            <span></span>
                        }
                        <div className="ml-auto p-3 btn-toolbar">
                            {/*<a href="javascript:void(0)" className="fa-2x">*/}
                                {/*<i style={{color: '#dcdcdc'}} className={'fas fa-star'}></i>*/}
                            {/*</a>*/}
                            {this.props.username ?
                            <Favourites
                                handleClickPlayCombination={this.handleClickPlayCombination}
                                handleClickDeleteCombination={this.handleClickDeleteCombination}
                                playingCombinationTitle={this.state.playingCombinationTitle}
                                buttonLabel="" combinations={this.state.combinations}/>
                                :
                                <span></span>
                            }
                            {/*<button className="btn btn-outline-secondary">*/}
                                {/*<span className="fa-layers fa-fw mute">*/}
                                    {/*<i style={{color: '#dcdcdc'}} className={'fas fa-volume-up'}></i>*/}
                                    {/*<i style={{color: '#2c303b'}} className="fa-inverse fas fa-times" data-fa-transform="shrink-6"></i>*/}
                                {/*</span>*/}
                            {/*</button>*/}
                            <div onClick={() => this.mute()}>
                                <button className={classNames('btn','btn-link','icon', {'d-none': !this.state.isMuted})}>
                                    <MutedIcon isMuted={isMuted}/>
                                </button>
                                <button className={classNames('btn','btn-link','icon', {'d-none': this.state.isMuted})}>
                                    <NonMutedIcon isMuted={isMuted}/>
                                </button>
                            </div>
                        </div>
                    </div>


                    <div className="row">
                        {this.renderSounds()}
                    </div>
                </div>
            </div>
        );
    }
}

export default SoundsList;


// WEBPACK FOOTER //
// ./src/SoundsList.js